(() => {
  const data = window.LTServiceAreaPostalCodes;
  const fiveDigits = /^\d{5}$/;
  // ZIP+4 is a valid postal format. Only the five-digit prefix is meaningful
  // for service-area lookup, so accept it instead of rejecting the address.
  const zipPlusFour = /^(\d{5})-\d{4}$/;

  const normalizePostalCode = (value) => {
    const postalCode = String(value || '').trim();
    if (fiveDigits.test(postalCode)) return postalCode;
    const plusFour = zipPlusFour.exec(postalCode);
    return plusFour ? plusFour[1] : null;
  };

  const findServiceArea = (value) => {
    const postalCode = normalizePostalCode(value);
    if (!postalCode || !Array.isArray(data?.serviceAreas)) return null;
    return data.serviceAreas.find((area) => area.postalCodes.includes(postalCode)) || null;
  };

  window.LTDeliveryEligibility = Object.freeze({ normalizePostalCode, findServiceArea });

  if (customElements.get('lt-delivery-eligibility')) return;

  class LTDeliveryEligibility extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-delivery-eligibility-form]');
      this.input = this.querySelector('[data-delivery-eligibility-input]');
      this.checkButton = this.querySelector('[data-delivery-eligibility-check]');
      this.result = this.querySelector('[data-delivery-eligibility-result]');
      if (!this.form || !this.input || !this.checkButton || !this.result) return;

      this.checkButton.addEventListener('click', () => {
        this.renderResult(this.input.value, true);
      });
      this.input.addEventListener('input', () => {
        const value = this.input.value.trim();
        if (value.length >= 5) {
          this.renderResult(value, false);
        } else {
          this.result.hidden = true;
          this.result.replaceChildren();
        }
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.renderResult(this.input.value, true);
        }
      });
    }

    renderResult(value, submitted) {
      const postalCode = normalizePostalCode(value);
      this.result.hidden = false;
      this.result.replaceChildren();

      if (!postalCode) {
        if (submitted || String(value).trim().length >= 5) {
          const message = document.createElement('p');
          message.textContent = 'Enter a five-digit ZIP code to check delivery.';
          this.result.append(message);
        } else {
          this.result.hidden = true;
        }
        return;
      }

      const area = findServiceArea(postalCode);
      if (area) {
        const message = document.createElement('p');
        const price = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        }).format(area.deliveryPriceCents / 100);
        message.textContent = `Delivery is available in ${area.label} for ${price}.`;
        this.result.append(message);
        return;
      }

      const message = document.createElement('p');
      message.textContent = 'This ZIP code is outside our current delivery area. Pickup remains available.';
      const contact = document.createElement('a');
      contact.className = 'button button--secondary lt-delivery-eligibility__contact-button';
      contact.href = this.dataset.contactUrl;
      contact.textContent = 'Sorry, we do not currently serve that location. Please reach out and let us know how we can help!';
      this.result.append(message, contact);
    }
  }

  customElements.define('lt-delivery-eligibility', LTDeliveryEligibility);
})();
